export default function genererContactUtilisateur() {
  return {
    identifiant: '',
    motPasse: '',
    motPasseConf: '',
  };
}
